import { Api, IApiResponse } from './Api';

export interface IUserRegistrationData {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    company: string;
}

export interface IChangePasswordData {
    userName: string;
    oldPassword: string;
    newPassword: string;
}

export interface IConfirmEmailData {
    token: string;
    uid: string;
}

export interface IForgotPasswordData {
    UserName: string;
    email: string;
}

export interface IResetPasswordData {
    email: string;
    password: string;
    token: string;
}

let apiResponse: IApiResponse = {
    data: null,
    error: false
}

export const UserService = {
    register: async (userData: IUserRegistrationData) => {
        try {
            const response = await Api.post("/users", userData);
            apiResponse.data = response.data;
            apiResponse.error = false;
        } catch (error) {
            apiResponse.data = error;
            apiResponse.error = true;
        }
        return apiResponse;
    },

    changePassword: async (changePasswordData: IChangePasswordData) => {
        try {
            const response = await Api.post("/users/changePassword", changePasswordData);
            apiResponse.data = response.data;
            apiResponse.error = false;
        } catch (error) {
            apiResponse.data = error;
            apiResponse.error = true;
        }
        return apiResponse;
    },

    confirmEmail: async (confirmEmailData: IConfirmEmailData) => {
        try {
            const response = await Api.post("/users/confirmEmail", confirmEmailData);
            apiResponse.data = response.data;
            apiResponse.error = false;
        } catch (error) {
            apiResponse.data = error;
            apiResponse.error = true;
        }
        return apiResponse;
    },

    resendConfirmationEmail: async (emailAddress: string) => {
        try {
            const response = await Api.get("/users/confirmEmail/" + emailAddress);
            apiResponse.data = response.data;
            apiResponse.error = false;
        } catch (error) {
            apiResponse.data = error;
            apiResponse.error = true;
        }
        return apiResponse;
    },
    
    forgotPassword: async (forgotPasswordData: IForgotPasswordData) => {
        try {
            const response = await Api.post("/users/forgotPassword", forgotPasswordData);
            apiResponse.data = response.data;
            apiResponse.error = false;
        } catch (error) {
            apiResponse.data = error;
            apiResponse.error = true;
        }
        return apiResponse;
    },

    resetPassword: async (resetPasswordData: IResetPasswordData) => {
        try {
            const response = await Api.post("users/resetPassword", resetPasswordData);
            apiResponse.data = response.data;
            apiResponse.error = false;
        } catch (error) {
            apiResponse.data = error;
            apiResponse.error = true;
        }
        return apiResponse;
    }
}